import {
  ALL_PERMISSIONS,
  Permissions,
  type PermissionId,
} from "./permissions";

export const Roles: Record<string, PermissionId[]> = {
  admin: ALL_PERMISSIONS.map((p) => p.id),

  stock_manager: [
    Permissions.branch.view,
    Permissions.branch.manage,
    Permissions.branch.assign_user,
    Permissions.branch.warehouse_manager,
    Permissions.branch.stock_controller,
    Permissions.stock.view,
    Permissions.stock.manage,
    Permissions.stock.service_view,
    Permissions.stock.service_manage,
    Permissions.stock.adjust,
    Permissions.stock.movement_view,
    Permissions.stock.lot_view,
    Permissions.stock.transfer_view,
    Permissions.stock.transfer_create,
    Permissions.stock.transfer_complete,
    Permissions.stock.transfer_receive,
    Permissions.stock.transfer_cancel,
    Permissions.procurement.view,
    Permissions.procurement.create,
    Permissions.procurement.approve,
    Permissions.procurement.receive,
    Permissions.order.view,
    Permissions.order.manage,
    Permissions.pos.access,
    Permissions.pos.return,
    Permissions.pos.return_approve,
    Permissions.pos.exchange,
    Permissions.pos.void,
    Permissions.pos.report_view,
    Permissions.sales_report.view,
    Permissions.stock_report.view,
    Permissions.stock_report.export,
    Permissions.stock_report.valuation_view,
  ],

  cashier: [
    Permissions.pos.access,
    Permissions.pos.sell,
    Permissions.pos.return,
    Permissions.pos.exchange,
    Permissions.pos.report_view,
    Permissions.stock.view,
    Permissions.stock.lot_view,
  ],
};

export const STOCK_ROLE_IDS = ["stock_manager", "cashier"] as const;
